import { SET_LOGOUT, CLEAR_ALL } from '../../../store/Types';

export const GETALL_CLASES = 'GETALL_CLASES';
export const LOADING_GETALL_CLASES = 'LOADING_GETALL_CLASES';
export const ACTIVO_CLASES = 'ACTIVO_CLASES';
export const PARAMS_CLASES = 'PARAMS_CLASES';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const clasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_CLASES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_GETALL_CLASES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case ACTIVO_CLASES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_CLASES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
